// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import {
  BackgroundColorEnum,
  BoelsTeaserComponentData,
  CardShapeEnum,
  TeasersGroupComponentData,
} from '@boels/models';

export const teaserSquareComponentData: TeasersGroupComponentData = {
  uid: 'clone_cmsitem_00094002_00067049',
  uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDk0MDAyXzAwMDY3MDQ5IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
  typeCode: 'TeasersGroupComponent',
  name: 'Clone Homepage_Product_teasers 00067062',
  container: 'false',
  backgroundColor: BackgroundColorEnum.GREY,
  removeBottomSpacing: false,
  shape: CardShapeEnum.SQUARE,
  children:
    'clone_cmsitem_00092051_00067050 clone_cmsitem_00093000_00067053 clone_cmsitem_00094001_00067056 clone_cmsitem_00133000_00067059',
  synchronizationBlocked: 'false',
  teasers:
    'clone_cmsitem_00092051_00067050 clone_cmsitem_00093000_00067053 clone_cmsitem_00094001_00067056 clone_cmsitem_00133000_00067059',
  title: 'Popular categories',
  modifiedTime: new Date('2022-07-01T12:19:15.947+02:00'),
};

export const teaserSquaresDataMock: BoelsTeaserComponentData[] = [
  {
    uid: 'clone_cmsitem_00093000_00067053',
    uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDkzMDAwXzAwMDY3MDUzIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'TeaserComponent',
    modifiedtime: '2022-07-01T10:33:45+0000',
    name: 'Homepage_Accugereedschap',
    container: 'false',
    image: {
      code: 'clone00067054',
      mime: 'image/jpeg',
      altText: 'Product-2_255x191.jpg',
      url: '/medias/Product-2-255x191.jpg?context=bWFzdGVyfHJvb3R8OTgyN3xpbWFnZS9qcGVnfGg4OC9oYjkvOTEyMjcyNDcwODM4Mi9Qcm9kdWN0LTJfMjU1eDE5MS5qcGd8NjFkYjEwMGQyZjdmZThkZmM2ZDY3NmZhMGRjOWQwNDY4MzVlZjJlODU0ZWZhMjYzN2VlNjhjMmY4ODA3ZmQyYg',
    },
    titleColor: 'GREY',
    synchronizationBlocked: 'false',
    link: {
      container: false,
      styleClasses: '1',
      categoryCode: 'ktsxgkah',
      uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDIzMDc2XzAwMDY3MDU1IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      linkName: 'Battery tools',
      url: '/c/ktsxgkah',
      typeCode: 'CMSLinkComponent',
      target: 'false',
      uid: 'clone_cmsitem_00023076_00067055',
      external: true,
      name: 'Accu gereedschap - Link',
      synchronizationBlocked: 'false',
      category: 'ktsxgkah',
    },
    title: 'Battery tools',
    parents: 'clone_cmsitem_00094002_00067049',
    backgroundGradient: false,
  },
  {
    uid: 'clone_cmsitem_00094001_00067056',
    uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDk0MDAxXzAwMDY3MDU2IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'TeaserComponent',
    modifiedtime: '2022-07-01T10:34:04+0000',
    name: 'Homepage_Lichtmastaggregaten',
    container: 'false',
    image: {
      code: 'clone00067057',
      mime: 'image/jpeg',
      altText: 'Product-3_255x191.jpg',
      url: '/medias/Product-3-255x191.jpg?context=bWFzdGVyfHJvb3R8NzA4MnxpbWFnZS9qcGVnfGhjNy9oYjgvOTEyMjcyNDc3MzkxOC9Qcm9kdWN0LTNfMjU1eDE5MS5qcGd8NDFhOTFmYzhjZWI4N2FmN2RmZDdkNDkwZGNmNDg4MjRjZjhlMzRmZTlhMGEyODlkOTczODkwOWQ4MWUzZjY2OA',
    },
    titleColor: 'GREY',
    synchronizationBlocked: 'false',
    link: {
      container: false,
      categoryCode: 'y1lcbocv',
      uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDk0MDAwXzAwMDY3MDU4IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      url: '/c/y1lcbocv',
      typeCode: 'CMSLinkComponent',
      target: 'false',
      uid: 'clone_cmsitem_00094000_00067058',
      external: true,
      name: 'Lichtmastaggregaten',
      synchronizationBlocked: 'false',
      category: 'y1lcbocv',
    },
    title: 'Lighting towers veryveryveryveryveryveryveryveryLongWord',
    parents: 'clone_cmsitem_00094002_00067049',
    backgroundGradient: false,
  },
  {
    uid: 'clone_cmsitem_00092051_00067050',
    uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDkyMDUxXzAwMDY3MDUwIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'TeaserComponent',
    modifiedtime: '2022-07-01T10:31:24+0000',
    name: 'Homepage_Schaarhoogwerkers',
    container: 'false',
    image: {
      code: 'clone00067051',
      mime: 'image/jpeg',
      altText: 'Product-1_255x191.jpg',
      url: '/medias/Product-1-255x191.jpg?context=bWFzdGVyfHJvb3R8OTE0N3xpbWFnZS9qcGVnfGg4Ni9oYmMvOTEyMjcyNDY0Mjg0Ni9Qcm9kdWN0LTFfMjU1eDE5MS5qcGd8NTMwMDM3NTdkYTFiZGJjOGYyOTM2OTU4NGZkMGE0NjYyMGM3OGM0N2ZlYmQzNjQyYjljOGVlZGM1NDc5M2JjMg',
    },
    titleColor: 'GREY',
    synchronizationBlocked: 'false',
    link: {
      container: false,
      categoryCode: 'lqz1ucpw',
      uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDk0MDAzXzAwMDY3MDUyIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      url: '/c/lqz1ucpw',
      typeCode: 'CMSLinkComponent',
      target: 'false',
      uid: 'clone_cmsitem_00094003_00067052',
      external: true,
      name: 'Schaarhoogwerkers - Assortiment',
      synchronizationBlocked: 'false',
      category: 'lqz1ucpw',
    },
    title: 'Scissor lifts - very long text test test test test test test testa',
    parents: 'clone_cmsitem_00094002_00067049',
    backgroundGradient: false,
  },
  {
    uid: 'clone_cmsitem_00133000_00067059',
    uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMTMzMDAwXzAwMDY3MDU5IiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
    typeCode: 'TeaserComponent',
    modifiedtime: '2022-05-18T07:43:25+0000',
    name: 'Graafmachines - Assortiment - Home',
    container: 'false',
    imageAltText: 'Excavators',
    image: {
      code: 'clone00067060',
      mime: 'image/jpeg',
      altText: 'Product-4_255x191.jpg',
      url: '/medias/Product-4-255x191.jpg?context=bWFzdGVyfHJvb3R8Njg2OHxpbWFnZS9qcGVnfGhjOC9oYjUvOTEyMjcyNDgzOTQ1NC9Qcm9kdWN0LTRfMjU1eDE5MS5qcGd8ZWI5ZTE2MmVjOGViNjBmYjMzN2ZiNTZkNmMxYjUzZTRlMWE2ZDIyMmJmNDEzNGFhNTg3NGRhM2ZmZGQ5YWEwMg',
    },
    titleColor: 'GREY',
    synchronizationBlocked: 'false',
    link: {
      container: false,
      categoryCode: 'mswwuznr',
      uuid: 'eyJpdGVtSWQiOiJjbG9uZV9jbXNpdGVtXzAwMDkyMDU0XzAwMDY3MDYxIiwiY2F0YWxvZ0lkIjoicmVudGFsTkxDb250ZW50Q2F0YWxvZyIsImNhdGFsb2dWZXJzaW9uIjoiT25saW5lIn0=',
      linkName: 'Excavators',
      url: '/c/mswwuznr',
      typeCode: 'CMSLinkComponent',
      target: 'false',
      uid: 'clone_cmsitem_00092054_00067061',
      external: true,
      name: 'Graafmachines - assortiment Home',
      synchronizationBlocked: 'false',
      category: 'mswwuznr',
    },
    title: 'Excavators',
    parents: 'clone_cmsitem_00094002_00067049',
    backgroundGradient: false,
  },
];
